var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg35(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 276,
    viewBox: "0 0 615 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.835 30.8625L403.16 83.0579L394.828 201.97L494.174 268.669L601.832 216.473L610.163 97.561L510.835 30.8625Z",
    fill: "#ACA4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.534 29.8345L257.893 62.4131L222.074 159.496L276.065 247.96L379.125 261.25L453.754 189.333L443.701 86.3425L356.534 29.8345Z",
    fill: "#776BCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.86 30.5404L65.2203 42.4083L21.3287 116.509L52.2394 197.027L134.615 223.372L206.514 175.701L213.739 89.8806L150.86 30.5404Z",
    fill: "#776BCE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg35);
export default __webpack_public_path__ + "static/media/35.85061603f8a7f88bf2e5e445585e26b6.svg";
export { ForwardRef as ReactComponent };